import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {ROUTE} from 'containers/App/constants';
import {ListHeader, Loading} from 'components';

import {
  downloadAllResults,
  downloadUserResults,
} from 'api/requests/wisbitRequests';

import WisbitList from './WisbitList';
import i18n from 'i18next';
import {push} from 'connected-react-router';
import {useLoadWisbit} from './hooks';
import {selectApp} from 'store/selectors';
import {USER_TYPE} from 'containers/ManageUserPage/userType';

function ManageWisbitPage() {
  const dispatch = useDispatch();

  const {user} = useSelector(selectApp);
  const {data, loading} = useLoadWisbit(dispatch);

  const isContentCreator = user.role === USER_TYPE.CONTENT_CREATOR.serverAlias;

  const onDownload = async () => {
    try {
      // Content creators may only download results for items they created
      if (isContentCreator) {
        await downloadUserResults(user.id);
      } else {
        await downloadAllResults();
      }
    } catch {
      console.error('Download failed!');
    }
  };

  const onAdd = isContentCreator
    ? () => dispatch(push(ROUTE.Wisbit.Template))
    : undefined;

  return (
    <>
      <ListHeader
        header={i18n.t('manageWisbitPage.headerLabel')}
        onDownload={onDownload}
        onAdd={onAdd}
      />
      {loading ? <Loading /> : <WisbitList data={data} />}
    </>
  );
}

export default ManageWisbitPage;
